
class ResponseService {
    static get HTTP_CODES() {
        return {
            // Success
            200: 'OK',
            201: 'Created',
            202: 'Accepted',
            203: 'Non-Authoritative Information',
            204: 'No Content',
            205: 'Reset Content',
            206: 'Partial Content',
            207: 'Multi-Status',
            208: 'Already Reported',
            226: 'IM Used',

            // Errors 400: Client
            400: 'Bad Request',
            401: 'Unauthorized',
            402: 'Payment Required',
            403: 'Forbidden',
            404: 'Not Found',
            405: 'Method Not Allowed',
            406: 'Not Acceptable',
            407: 'Proxy Authentication Required',
            408: 'Request Timeout',
            409: 'Conflict',
            410: 'Gone',
            411: 'Length Required',
            412: 'Precondition Failed',
            413: 'Payload Too Large',
            414: 'URI Too Long',
            415: 'Unsupported Media Type',
            416: 'Range Not Satisfiable',
            417: 'Expectation Failed',
            418: "I'm a teapot",
            421: 'Misdirected Request',
            422: 'Unprocessable Entity',
            423: 'Locked',
            424: 'Failed Dependency',
            425: 'Too Early',
            426: 'Upgrade Required',
            428: 'Precondition Required',
            429: 'Too Many Requests',
            431: 'Request Header Fields Too Large',
            451: 'Unavailable For Legal Reasons',

            // Errors 500: Server
            500: 'Internal Server Error',
            501: 'Not Implemented',
            502: 'Bad Gateway',
            503: 'Service Unavailable',
            504: 'Gateway Timeout',
            505: 'HTTP Version Not Supported',
            506: 'Variant Also Negotiates',
            507: 'Insufficient Storage',
            508: 'Loop Detected',
            510: 'Not Extended',
            511: 'Network Authentication Required'
        };
    }

    processError(error) {
        console.log(JSON.stringify(error))
        if( !error.response ) {
            error.response = {};
            error.response.data = {};
            error.response.data.title = null;
            error.response.status = NaN;
            error.response.data.timestamp = new Date();
            error.response.data.message = error.message;
            error.response.data.content = error.stack;
        }
        let errorTitle;
        if (error.response && error.response.data && error.response.data.title) {
            errorTitle = error.response.data.title;
          } else {
            errorTitle = error.response.status < 500 ? 'Client error' : 'Server error';
        }
        let variant;
        if( error.response.status < 300 ) {
            variant = 'success';
        } else if( error.response.status < 500 ) {
            variant = 'warning';
        } else variant = 'danger';
        const procesableError = {
            variant: variant,
            title: errorTitle,
            statusCode: error.response.status,
            statusText: ResponseService.HTTP_CODES[error.response.status],
            timestamp: error.response.data && error.response.data.timestamp ? error.response.data.timestamp : undefined,
            message: error.response.data.message,
            content: error.response.data.content,
            url: error.config.url
        };
        if( error.response.status === 401 || error.response.status === 403 ) {
            console.log('logout');
        }
        return procesableError;
    }

    processResponse(response) {
        const processableResponse =  {
            variant: 'success',
            title: response.data.title ? response.data.title : 'Success',
            statusCode: response.status,
            statusText: ResponseService.HTTP_CODES[response.status],
            message: response.data.message,
            content: response.data.content,
            url: response.config.url
        }
        return processableResponse;
    }
}

export default new ResponseService();